import type { ActiveReviewDraft } from "./types";

export function getNowIso(date = new Date()): string {
  return date.toISOString();
}

export function getElapsedSeconds(
  accumulatedSeconds: number,
  currentSegmentStartedAt?: string | null,
  now = new Date(),
): number {
  if (!currentSegmentStartedAt) {
    return accumulatedSeconds;
  }

  const elapsedMs = now.getTime() - new Date(currentSegmentStartedAt).getTime();
  return accumulatedSeconds + Math.max(0, Math.floor(elapsedMs / 1000));
}

export function getDraftDurationSeconds(
  draft: Pick<ActiveReviewDraft, "accumulatedSeconds" | "currentSegmentStartedAt">,
  now = new Date(),
): number {
  return getElapsedSeconds(draft.accumulatedSeconds, draft.currentSegmentStartedAt, now);
}

export function formatDuration(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds].map((value) => String(value).padStart(2, "0")).join(":");
}
